import axios from 'axios';
import { createContext, useRef, useState } from "react";
import {
    ADD_COMMENTS_URL,
    EVENTS_BASE_URL,
    FAMILY_USERS,
    GUEST_ADMIN,
    GET_HISTORY_URL,
    PROCESS_INVITATION,
    EVENT_ATTACHMENTS_URL,
    EVENT_BRIEFS_URL
} from './ApiDetails.js';

const FormContext = createContext({});
export const FormProvider = ({ children }) => {
    const title = {
        0: 'Event',
        1: 'Schedule',
        2: 'Guests',
        3: 'Summary'
    }
    const [attachments, setAttachments] = useState([])
    const [briefs, setBriefs] = useState([]);
    const [page, setPage] = useState(0)
    const [editable, setEditable] = useState(false)
    const hiddenUploadImageFileInput = useRef(null);
    const [familyUsers, setFamilyUsers] = useState([])
    const [files, setFiles] = useState([]);
    const [comments, setComments] = useState({
        EventSection: '',
        DraftSection: '',
        VisitSection: '',
        BriefSection: '',
        AttachmentSection: '',
        HistorySection: ''
    })
    const [eventFormData, setEventFormData] = useState({
        // Initialize your form data state here
        requestedBy: '',
        eventTitle: '',
        associateSegment: '',
        email: '',
        phone: '',
        phoneCode: '',
        eventDate: '',
        siteCode: '',
        countryName: '',
        stateName: '',
        cityName: '',
        eventVenueName: '',
        eventAddress: '',
        eventType: '',
        eventFormat: '',
        totalAttendees: 0,
        petcareAttendees: 0,
        schedule: {
            visitSummary: '',
            draftItinerary: ''
        },
        maxFamilyNum: false,
        familyNum: 1,
        specificFamilyMem: false,
        nameOfMem: '',
        IsScheduleChange: false,
        lastVisit: '',
        associates: '',
        IsImageCover: false,
        eventId: 0,
        eventStatus: 'Draft',
        eventEndDate: '',
    });

    const [guestDetails, setGuestDetails] = useState({
        guests: [],
        SeatsRequired: 0,
        UnderReview: 0,
        Confirmed: 0
    })
    const [userAcceptConfirmed, setUserAcceptConfirmed] = useState(false);
    const [userDeclined, setUserDeclined] = useState(false);
    const [userTentative, setUserTentative] = useState(false);

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.name === "imageFile") {
            setEventFormData({ ...eventFormData, IsImageCover: false });
            const bgUrl = URL.createObjectURL(e.target.files[0]);
            document.getElementById("hdrDiv").style.backgroundImage = "url(" + bgUrl + ")";
        }
    };


    const handleUploadImageClick = () => {
        hiddenUploadImageFileInput.current.click();
    };

    const handlepageChange = (val) => {
        setPage(val);
        if (val === 1) {
            onScheduleLoad()
        }
        if (val === 3) {
            onHistoryLoad()
        }
    }

    const getEventById = async (eventID) => {
        try {
            const response = await axios.get(`${EVENTS_BASE_URL}/${eventID}`);
            const data = response.data;
            if (data != null) {
                const updatedEventFormData = { ...eventFormData };
                updatedEventFormData.id = data.id;
                updatedEventFormData.eventId = data.eventId;
                updatedEventFormData.requestedBy = data.requestedBy;
                updatedEventFormData.eventTitle = data.eventTitle;
                updatedEventFormData.eventStatus = data.eventStatus;
                updatedEventFormData.associateSegment = data.associateSegment;
                updatedEventFormData.countryName = data.countryName;
                updatedEventFormData.stateName = (data.stateName != null) ? data.stateName.trim() : null;
                updatedEventFormData.cityName = (data.cityName != null) ? data.cityName.trim() : null;
                updatedEventFormData.email = data.email;
                updatedEventFormData.phone = data.phone;
                updatedEventFormData.phoneCode = data.phoneCode;
                updatedEventFormData.eventDate = data.eventDate;
                updatedEventFormData.eventEndDate = data.eventEndDate;
                updatedEventFormData.siteCode = data.siteCode;
                updatedEventFormData.otherSiteCode = data.otherSiteCode;
                updatedEventFormData.lastVisit = data.lastVisit;
                updatedEventFormData.isDateFlexible = data.isDateFlexible;
                updatedEventFormData.eventVenueName = data.eventVenueName;
                updatedEventFormData.eventAddress = data.eventAddress;
                updatedEventFormData.eventType = data.eventType;
                updatedEventFormData.eventFormat = data.eventFormat;

                if (data.siteCode === "OFF") {
                    setSearchAddress(data.eventAddress);
                }

                updatedEventFormData.otherEventType = data.otherEventType;
                updatedEventFormData.otherEventFormat = data.otherEventFormat;

                updatedEventFormData.eventCoHost = data.eventCoHost;
                updatedEventFormData.coHostEmail = data.coHostEmail;
                updatedEventFormData.maxFamilyNum = false; //data.maxFamilyNum;
                updatedEventFormData.familyNum = data.familyNum;
                updatedEventFormData.specificFamilyMem = data.specificFamilyMem;
                updatedEventFormData.nameOfMem = data.nameOfMem;
                updatedEventFormData.associates = data.associates;
                updatedEventFormData.petcareAttendees = data.petcareAttendees;

                if (data.schedule != null) {
                    const sch = {};
                    sch.visitSummary = data.schedule.visitSummary || "";
                    sch.draftItinerary = data.schedule.draftItinerary || "";
                    updatedEventFormData.schedule = sch;
                }

                updatedEventFormData.totalAttendees = data.totalAttendees;

                statusHiglight(data.eventStatus);
                if (data.eventStatus === 'Rejected') {
                    setRejectEventPage()
                }

                handleGuestData();

                setEventFormData(updatedEventFormData);

                getFamilyUserList();
            }
        } catch (error) {
            console.error('Error getting event data', error);
        }
    };

    const handleGuestData = async () => {
        if (eventFormData.eventId !== 0) {
            try {
                await axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}/${GUEST_ADMIN}`)
                    .then(response => {
                        if (response.data.guests !== null) {
                            var guestDetails = {}
                            guestDetails.SeatsRequired = response.data.seatsRequired
                            guestDetails.UnderReview = response.data.underReview
                            guestDetails.Confirmed = response.data.confirmed

                            var guestList = []
                            response.data.guests.forEach(element => {
                                if ((element.userId==localStorage.getItem('userId')) && (element.status=="Confirmed")) {
                                  setUserAcceptConfirmed(true);
                                }
                                if ((element.userId==localStorage.getItem('userId')) && (element.status=="Declined")) {
                                  setUserDeclined(true);
                                }
                                if ((element.userId==localStorage.getItem('userId')) && (element.status=="Tentative")) {
                                  setUserTentative(true);
                                }
                                guestList.push({
                                    'id': element.userId,
                                    'name': element.fullname,
                                    'status': element.status
                                })
                            })
                            guestDetails.guests = guestList
                            setGuestDetails(guestDetails)
                        }
                    })
            } catch (error) {
                console.error('Error get guest data', error);
            }
        }

    }

    const statusHiglight = (status) => {
        var eventStatusTab = document.getElementById("eventStatusTab");
        if (eventStatusTab == null) return;
        var ele = eventStatusTab.childNodes;
        ele.forEach(element => {
            element.className = "btn-custom btn btn-default"

        });
        switch (status) {
            case "Draft":
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Under review":
                document.getElementById("UnderReview").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Open event":
                document.getElementById("OpenEvent").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Attendance confirmed":
                document.getElementById("AttendanceConfirmed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Pending documentation":
                document.getElementById("PendingDocumentation").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Completed":
                document.getElementById("Completed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Rejected":
                if (document.getElementById("Rejected")) document.getElementById("Rejected").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Cancelled":
                if (document.getElementById("Cancelled")) document.getElementById("Cancelled").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            default:
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
        }
    }

    const onScheduleLoad = async () => {
        if (eventFormData.eventId !== 0) {
            axios.get(`${EVENT_BRIEFS_URL}/${eventFormData.eventId}`)
                .then(async response => {
                    if (response.data != null && response.data.length != 0) {
                        setBriefs(response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching brief file or file data', error);
                });

            axios.get(`${EVENT_ATTACHMENTS_URL}/${eventFormData.eventId}`)
                .then(response => {
                    if (response.data != null && response.data.length != 0) {
                        setAttachments(response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching attachments', error);
                });
        }
    }

    const [headerRefresh, setHeaderRefresh] = useState(false);
    const refreshNotifications = () => {
        setHeaderRefresh(!headerRefresh);
    }

    const addComments = async (comment, isHistory) => {

        if (eventFormData.eventId !== 0) {
            let briefData = new FormData();
            briefData.append("EventId", eventFormData.eventId);
            briefData.append("Comments", comment);

            axios.post(ADD_COMMENTS_URL, briefData)
                .then(response => {
                    if (response.data != null) {
                        alert("Comment added");
                        refreshNotifications();
                        if (isHistory)
                            createHistoryElements(response.data.comments, response.data.date, response.data.user, response.data.userRole, true)
                    }
                    else
                        alert("Error adding comments");
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error adding comments");
                });
        }
    }

    const addCommentsEventSection = () => { addComments(comments.EventSection, false) }
    const addCommentsDraftSection = () => { addComments(comments.DraftSection, false) }
    const addCommentsVisitSection = () => { addComments(comments.VisitSection, false) }
    const addCommentsBriefSection = () => { addComments(comments.BriefSection, false) }
    const addCommentsAttachmentSection = () => { addComments(comments.AttachmentSection, false) }
    const addCommentsHistorySection = () => { addComments(comments.HistorySection, true) }

    const setRejectEventPage = () => {
        var saveChanges = document.getElementById("rejectEvent")
        var sendValidation = document.getElementById("editEvent")
        var closeEdit = document.getElementById("ValidateOpen")
        var deleteDraft = document.getElementById("ReturnToRequestor")
        if (saveChanges) saveChanges.hidden = true
        if (sendValidation) sendValidation.hidden = true
        if (closeEdit) closeEdit.hidden = true
        if (deleteDraft) deleteDraft.hidden = true
    }

    const handleClick = async (status, comment) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        await ProcessEventInvitation(status, comment);
    }

    const ProcessEventInvitation = async (status, comment) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        try {
            // Prepare data for processing invitation
            const data = new FormData();
            data.append("status", status);
            data.append("comment", comment);

            // Call Process Invitation API
            const response = await axios.post(`${PROCESS_INVITATION}/${eventFormData.eventId}`, data);
            if (response.data == 0) {
                alert("Error in processing invitation, response.data:", response.data);
                return;
            }

            const acceptButton = document.getElementById("ValidateOpen");
            if (acceptButton) {
                acceptButton.style.display = 'none';
            }

            window.location.reload();
        } catch (error) {
            console.error("Error in processing invitation:", error);
            alert("Error in processing invitation:", error);
        }
    };

    const EditEvent = () => {
        setEditable(true);
        var elementArray = document.getElementsByClassName("editable")
        for (var i = 0; i < elementArray.length; i++) {
            if (elementArray[i]) {
                elementArray[i].hidden = false;
            }
        }
    };

    const onHistoryLoad = async () => {
        if (eventFormData.eventId == 0) {
            return;
        }

        await axios.get(`${GET_HISTORY_URL}/${eventFormData.eventId}`)
            .then(response => {
                if (response.data.length == 0) {
                    return;
                }
                var eleh = document.getElementById("History");
                if (eleh) eleh.innerHTML = "";

                response.data.forEach(element => {
                    if (element.history != null)
                        createHistoryElements(element.history, element.date, element.user, element.userRole, false)

                    if (element.comments != null)
                        createHistoryElements(element.comments, element.date, element.user, element.userRole, true)
                });
            });
    }

    const createHistoryElements = (data, date, user, userRole, isComment) => {
        var eleh = document.getElementById("History")

        //Date Div
        var dateDiv = document.createElement("div")
        dateDiv.className = "form-group row mb-2 align-items-center"

        //date label
        var datelabel = document.createElement("label")
        datelabel.className = "custom-font col-sm-2 col-form-label"
        datelabel.innerText = new Date(date).toLocaleDateString('en-US', {timeZone: 'UTC'});

        //div user
        var userDiv = document.createElement("div")
        userDiv.className = "col-sm-2 "

        var userStrong = document.createElement("strong")
        var userInput = document.createElement("input")
        userInput.type = "text"
        userInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        userInput.value = user
        userStrong.appendChild(userInput);

        //role
        var roleInput = document.createElement("input")
        roleInput.type = "text"
        roleInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        roleInput.value = userRole

        //comments
        var commentsDiv = document.createElement("div")
        commentsDiv.className = "form-group row mb-2"

        var commentsDiv1 = document.createElement("div")
        commentsDiv1.className = "col-sm-12 "

        var commentsInput = document.createElement("div");
        commentsInput.style.whiteSpace = "pre-wrap";
        commentsInput.style.wordWrap = "break-word";
        commentsInput.className = "custom-font-lt form-control";
        commentsInput.textContent = data;

        if (isComment)
            commentsInput.className = "custom-font-lt form-control comment"

        if (eleh != null) {
            commentsDiv1.appendChild(commentsInput)
            commentsDiv.appendChild(commentsDiv1)

            userDiv.appendChild(userStrong)
            userDiv.appendChild(roleInput)

            dateDiv.appendChild(datelabel)
            dateDiv.appendChild(userDiv)
            eleh.appendChild(dateDiv)
            eleh.appendChild(commentsDiv)
        }

    }

    const getFamilyUserList = () => {
        if (eventFormData.eventId === 0) {
            return;
        }

        axios.get(FAMILY_USERS)
            .then(response => {
                if (response.data == null) {
                    console.error('Error updating the family user details');
                    return;
                }

                setFamilyUsers(response.data);
            })
            .catch(error => {
                console.error('Error updating the family user details: ', error);
            });
    };

    const [searchAddress, setSearchAddress] = useState("");
    const [isEventOffSite, setIsEventOffSite] = useState(false);

    return (
        <FormContext.Provider value={{
            title, eventFormData, setEventFormData, handleChange, getEventById,
            handlepageChange, page, setPage, comments, setComments, addCommentsEventSection,
            addCommentsDraftSection, addCommentsVisitSection, addCommentsBriefSection, addCommentsAttachmentSection,
            addCommentsHistorySection, editable, guestDetails, ProcessEventInvitation,
            EditEvent, familyUsers, setFamilyUsers, files, setFiles, handleUploadImageClick,
            hiddenUploadImageFileInput, handleClick, attachments, briefs,
            searchAddress, setSearchAddress,
            isEventOffSite, setIsEventOffSite, 
            userAcceptConfirmed, setUserAcceptConfirmed, userDeclined, setUserDeclined, userTentative, setUserTentative,
            headerRefresh, setHeaderRefresh, refreshNotifications
        }}>
            {children}
        </FormContext.Provider>
    )
}
export default FormContext